import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-final-form";
import * as yup from "yup";
import { Grid } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import UiInput from "../../../../../../_uiComponents/UiInput";
import UiSelect from "../../../../../../_uiComponents/common/form/UiSelect";
import {
     UiButton,
     UiToggleButton,
} from "../../../../../../_uiComponents/common/form/UiButton";
import UiInnerSearchWr from "../../../../../../_uiComponents/common/UiInnerSearchWr";
import UiDateRangePicker from "../../../../../../_uiComponents/common/form/UiDateRangePicker";
import Validator from "../../../../../../../_helpers/validate.schema";
import UiMultipleSelect from '../../../../../../_uiMocks/_uiComponents/UiMultipleSelect';

// import {
//      getTemplateLabelsRequest,
//      getTemplateTypesRequest,
// } from "../../../../_redux/_actions";

const options = [
     { value: "value-1", label: "Admin" },
     { value: "value-2", label: "Admin" },
     { value: "value-3", label: "Admin" },
];

const validateSchema = () =>
     yup.object().shape({
          // name: yup.string().required("Name is required."),
          // type: yup.string().required("Type is required."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function ContentRevisionFilterForm(props) {
     const actionDispatch = useDispatch();


     useEffect(() => {
          // actionDispatch(getTemplateLabelsRequest());
          // actionDispatch(getTemplateTypesRequest());
     }, []);


     const submit = async (values) => {
          // if (values.typeId) {
          //      values.dataTemplateTypeId = values.typeId;
          // }

          // props.getFactTableList({ ...values });
     };



     return (
          <Form
               onSubmit={submit}
               validate={onValidate}
               render={({ form, handleSubmit }) => {
                    return (
                         <form onSubmit={validateSchema}>
                              <>
                                   <UiInnerSearchWr>
                                        <Grid container spacing={2}>
                                             <Grid item xs={12} lg="9">
                                                  <Grid container spacing={2}>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                            className="sba-search-input"
                                                       >
                                                            <UiInput
                                                                 name="revision"
                                                                 type="text"
                                                                 label="Revision"
                                                            />
                                                       </Grid>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                            className="sba-search-input"
                                                       >
                                                            <UiMultipleSelect
                                                                 name="type"
                                                                 label="Updated By"

                                                            />
                                                       </Grid>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                       >
                                                            <UiDateRangePicker
                                                                 rangeName="Updated on"
                                                                 name="dateRangeInput"
                                                            />
                                                       </Grid>


                                                  </Grid>
                                             </Grid>
                                             <Grid item xs={12} lg={3}>
                                                  <Stack
                                                       spacing={2}
                                                       direction="row"
                                                       justifyContent="end"
                                                       sx={{
                                                            width: "100%",
                                                            pt: 0.6,
                                                       }}
                                                  >
                                                       <UiButton
                                                            name="Clear"
                                                            variant="outlined"
                                                            size="small"
                                                            onClick={() => {
                                                                 form.reset();
                                                                 submit({});
                                                            }}
                                                       />
                                                       <UiButton
                                                            name="Apply"
                                                            variant="contained"
                                                            size="small"
                                                            onClick={
                                                                 handleSubmit
                                                            }
                                                       />
                                                  </Stack>
                                             </Grid>
                                        </Grid>
                                   </UiInnerSearchWr>
                              </>
                         </form>
                    );
               }}
          />
     );
}
